import * as React from 'react';
import Button from '@mui/material/Button';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import DeleteIcon from '@mui/icons-material/Delete';
import Fab from '@mui/material/Fab';
import TextField from '@mui/material/TextField';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export default function RecycleFirstPrompt(props) {
    const imageInputRef = React.useRef(null);
    const [images, setImages] = React.useState([]);
    const [comments, setComments] = React.useState('');
    const [validationErrors, setValidationErrors] = React.useState({});

    function handleUploadImageClick(event) {
        let file = event.target.files[0];
        const reader = new FileReader();
        var url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {


            // resize the imagage
            var img = document.createElement("img");
            img.onload = function (event) {
                var MAX_WIDTH = 1024;
                var MAX_HEIGHT = 1024;

                var width = img.width;
                var height = img.height;

                // Change the resizing logic
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                // Actual resizing
                ctx.drawImage(img, 0, 0, width, height);



                // Show resized image in preview element
                var dataurl = canvas.toDataURL(file.type);
                //document.getElementById("preview").src = dataurl;

                let imagesCopy = images.slice();
                imagesCopy.push({
                    imageId: uuidv4(),
                    imageData: dataurl
                });
                setImages(imagesCopy);
            }
            img.src = reader.result;


        }.bind(this);
    };

    function removeImage(imageId) {
        let imagesCopy = [];
        for (let i = 0; i < images.length; i++) {
            if (images[i].imageId !== imageId) {
                imagesCopy.push(images[i]);
            }
        }

        setImages(imagesCopy);
    }

   
    function getImages() {
        if (images !== null && images.length > 0) {

            return (

                <div className="images">
                    <div key={images[0].imageId}>
                        {/*<Fab onClick={() => removeImage(images[0].imageId)}>*/}
                        {/*    <DeleteIcon sx={{ color: 'var(--button-delete)' }} />*/}
                        {/*</Fab>*/}
                        <img
                            src={images[0].imageData}

                        />
                    </div>
                </div>);

        }
        else {
            return null;
        }

    }

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    function validate() {
        let isValid = true;
        let errors = {};

        if (comments.trim() == '') {
            isValid = false;
            errors.comments = 'Required';
        }

        if (images.length == 0) {
            isValid = false;
            errors.image = 'Required';
        }

        setValidationErrors(errors);
        if (isValid) {

            let recycleFirstInfo = {
                comments: comments.trim(),
                photoData: images[0].imageData
            }
            props.onClose(true, recycleFirstInfo);

        }

    }

    return (
        <div>
            
                <div>Would you like to return these cans and bottles prior to purchase?</div>
                <div style={{ marginTop: '10px' }}>You will be paying on the actual counts returned and not the customer's estimate or count.</div>
                <div style={{ marginTop: '10px' }}> <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center', float: 'left' }} />The payment process will require you to upload photos of the bottle receipts.</div>
            <div style={{ marginTop: '10px' }}>Please let the <span style={{fontWeight:'bold'} }>customer</span> know why you would like to return them first (order is very large, too many non-returnables, etc). </div>
            

            <div>
                <div style={{ marginTop: '10px', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                    <TextField label='Reason'
                        style={{ width: '300px' } }
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                        multiline rows={4} 
                        error={validationErrors.comments !== undefined} />
                </div>
                <>
                    {images === null || images.length == 0 ?
                        <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', marginTop: '10px' }}>
                            <Button variant='outlined' onClick={() => imageInputRef.current.click()} style={{ color: validationErrors.image !== undefined ? '#cc0000' : 'black', borderColor: validationErrors.image !== undefined ? '#cc0000' : 'black' }}>
                                Take a photo of the pickup
                                <AddAPhotoIcon sx={{ color: validationErrors.image !== undefined ? '#cc0000' : 'black' }} />
                            </Button>
                            <input
                                ref={imageInputRef}
                                style={{ display: 'none' }}
                                accept="image/*"
                                id="contained-button-file"
                                multiple
                                type="file"
                                onChange={handleUploadImageClick}
                            />
                        </div>
                        : null
                    }
                    <div style={{ display: 'flex', marginTop: '15px' }}>
                        {getImages()}
                    </div>
                </>

                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button variant='outlined' onClick={() => props.onClose(false, null)}>Cancel</Button>
                    <Button variant='outlined' onClick={() => validate()} autoFocus>Confirm</Button>
                </div>
            </div>
        </div>
    )
}